<c-full-page-layout [hasFooter]="true">
  <div full-page-header>
    <div class="sign-document-overview__header">
      <c-button
        type="secondary"
        [iconOnly]="true"
        [icon]="backIcon"
        (action)="back()" />

      <h1 class="sign-document-overview__title">
        {{ 'my-documents.sign-batch.overview.title' | transloco: { numberOfDocuments: total() } }}
      </h1>

      <c-button
        type="secondary"
        [iconOnly]="true"
        [icon]="closeIcon"
        [ariaLabel]="'common.close' | transloco"
        (action)="close()" />
    </div>
  </div>

  <div full-page-content>
    <div class="sign-document-overview__content">
      <p class="sign-document-overview__intro">
        {{ 'my-documents.sign-batch.overview.intro' | transloco }}
      </p>

      <ul class="sign-document-overview__list">
        @for (document of documents(); track document.index) {
          <li>
            <button
              type="button"
              class="sign-document-overview__item"
              (click)="open(document.index)">
              <span
                class="sign-document-overview__icon"
                [class.sign-document-overview__icon--agreed]="document.agreed">
                <c-icon [icon]="fileIcon" />
              </span>

              <span class="sign-document-overview__text">
                <span class="sign-document-overview__name">{{ document.name }}</span>

                @if (document.agreed) {
                  <span class="sign-document-overview__badge">
                    {{ 'my-documents.sign-batch.overview.agreed' | transloco }}
                  </span>
                } @else {
                  <span class="sign-document-overview__status">
                    {{ 'my-documents.sign-batch.overview.not-agreed' | transloco }}
                  </span>
                }
              </span>

              <c-icon class="sign-document-overview__chevron" [icon]="chevronIcon" />
            </button>
          </li>
        }
      </ul>
    </div>
  </div>

  <div full-page-footer>
    <div class="sign-document-overview__footer">
      @if (!allAgreed()) {
        <p class="sign-document-overview__remaining">
          {{ 'my-documents.sign-batch.overview.remaining' | transloco: { count: remaining() } }}
        </p>
      }

      <c-button
        iconPosition="end"
        [icon]="signIcon"
        [disabled]="!allAgreed()"
        (action)="sign()">
        {{ 'my-documents.sign-batch.overview.sign' | transloco }}
      </c-button>
    </div>
  </div>
</c-full-page-layout>
